export const environment = {
    configurationUrl: 'assets/app.config.json'
};
